import * as moment from 'moment';

export const updateLocalStorage = (storageKey: string, object: object) =>
    localStorage.setItem(storageKey, JSON.stringify(object));

export const setToLocalStorage = (storageKey: string, key: string, value: any) =>
    {
        Date.prototype.toJSON = function() { return moment(this).format('YYYY-MM-DDTHH:mm:ss'); };

        localStorage.setItem(storageKey, JSON.stringify({
            ...getFromLocalStorage(storageKey),
            [key]: value
        }));
    };

export function getFromLocalStorage<T>(storageKey: string): T {
    Date.prototype.toJSON = function() { return moment(this).format('YYYY-MM-DDTHH:mm:ss'); };

    return JSON.parse(localStorage.getItem(storageKey));
}

export const removeFromLocalStorage = (storageKey: string) =>
    localStorage.removeItem(storageKey);

export function removeValueFromObject<T>(object: T, key: string): T {
    delete object[key];
    return object;
}
